/** Sentinel for inspection list filter: include every control point (not a real UUID). */
export const ALL_CONTROL_POINTS_ID = "__ALL__";

export interface ControlPoint {
    id: string;
    name: string;
}
